import {FC} from 'react'
import {gql} from '@apollo/client'
import {useQuery} from 'hooks/graphql'
import {MultiTagFilteringFieldRow} from 'components/SearchForm/MultiTagFilteringFieldRow'
import {withNull} from 'libs/options'
import {useFormContext, useWatch} from 'react-hook-form'
import {Schema} from '../schema'

const NATIONAL_TYPES = gql`
  query nationalTypes {
    client {
      employeeConnections {
        nations {
          id
          name
        }
        visaTypes {
          id
          name
        }
      }
    }
  }
`

interface NationalTypesQueryResult {
  client: {
    employeeConnections: {
      nations: {
        id: string
        name: string
      }[]
      visaTypes: {
        id: string
        name: string
      }[]
    }
  }
}

const nationalTypesList = [
  {id: 'japanese', name: '日本人'},
  {id: 'foreigner', name: '外国人'},
]

export const NationalTypes: FC = () => {
  const {data} = useQuery<NationalTypesQueryResult>(NATIONAL_TYPES, {fetchPolicy: 'cache-and-network'})
  const nations = data?.client?.employeeConnections?.nations || []
  const visaTypes = data?.client?.employeeConnections?.visaTypes || []

  const {control, setValue} = useFormContext<Schema>()
  const nationalTypes = useWatch({control, name: 'nationalTypes'})

  // 外国人区分から「外国人」が外された時、国籍と在留資格をクリアする
  const handleChangeNationalTypes = (value: string[], prevValue: string[]) => {
    if (!value.includes('foreigner') && prevValue.includes('foreigner')) {
      setValue('nationIds', [])
      setValue('visaTypeIds', [])
    }
  }

  // 国籍または在留資格が選択された時、外国人区分を自動でセットする
  const autofillForeigner = (value: string[], prevValue: string[]) => {
    if (value.length > 0 && prevValue.length === 0 && !nationalTypes?.includes('foreigner')) {
      setValue('nationalTypes', [...(nationalTypes || []), 'foreigner'])
    }
  }

  return (
    <div style={{width: '100%'}}>
      <MultiTagFilteringFieldRow
        header="外国人区分"
        name="nationalTypes"
        list={withNull(nationalTypesList)}
        onChange={handleChangeNationalTypes}
        shouldUnregister
      />
      <MultiTagFilteringFieldRow
        header="国籍"
        name="nationIds"
        list={withNull(nations)}
        onChange={autofillForeigner}
        shouldUnregister
      />
      <MultiTagFilteringFieldRow
        header="在留資格"
        name="visaTypeIds"
        list={withNull(visaTypes)}
        onChange={autofillForeigner}
        shouldUnregister
      />
    </div>
  )
}
